import styled from 'styled-components'

export const MyDivide = styled.div<{
  space?: number
  dark?: Boolean
}>`
  height: 1px;
  background-color: ${props =>
    props.dark ? props.theme.dark3 : props.theme.light1};
  margin: ${props => `${props.space || 40}px auto`};
`
